import { render, staticRenderFns } from "./inputBeratTambahan.vue?vue&type=template&id=4cae2fbb&"
import script from "./inputBeratTambahan.vue?vue&type=script&lang=js&"
export * from "./inputBeratTambahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports